export default __webpack_public_path__ + "static/media/icon-3.c7320fd7.svg";